import { UploadFile } from '@mui/icons-material';
import { FormControl, FormHelperText } from '@mui/material';
import { useCallback, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { UseControllerProps, useController } from 'react-hook-form';
import { MDTypography } from '../MDTypography';
import { toast } from 'react-toastify';

interface IProps extends UseControllerProps {
    height?: number;
    width?: number | string;
    isExcel?: boolean;
}

export default function AppDropzone(props: IProps) {
    const { fieldState, field } = useController({ ...props, defaultValue: '' });

    const dzStyles = {
        display: 'flex',
        border: 'dashed 3px #eee',
        borderColor: fieldState.error ? "red" : "black",
        borderRadius: '5px',
        alignItems: 'center',
        justifyContent: 'center',
        height: props.height || 200,
        width: props.width || 500
    }

    const dzActive = {
        borderColor: 'green'
    }

    const onDrop = useCallback(acceptedFiles => {
        const fileType = acceptedFiles[0].type;
        const acceptedExcelFileTypes = [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/vnd.ms-excel.sheet.macroEnabled.12'
        ];
        const isExcelFile =  acceptedExcelFileTypes.includes(fileType);
        const isFileExtensionCSV = acceptedFiles[0].name.substring(acceptedFiles[0].name.length, acceptedFiles[0].name.length-4) === ".csv"; //Firefox file type fix

        if ((isExcelFile && props.isExcel && !isFileExtensionCSV) || ((fileType === 'text/csv' || isFileExtensionCSV) && !props.isExcel)) {
            acceptedFiles[0] = Object.assign(acceptedFiles[0], { preview: URL.createObjectURL(acceptedFiles[0]) })
            field.onChange(acceptedFiles[0]);
        } else {
            const message = `Only ${props.isExcel ? 'Excel' : 'CSV'} files are accepted`;
            toast.error(message);
        }
    }, [field, props.isExcel]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return (
        <div {...getRootProps()}>
            <FormControl style={isDragActive ? { ...dzStyles, ...dzActive } : dzStyles} error={!!fieldState.error}>
                <input {...getInputProps()} accept={props.isExcel ? '.xlsm, .xlsx, .xls' : '.csv'} />
                <div style={
                    isDragActive ? { color: 'green', display: 'flex', flexDirection: 'column', alignItems: 'center' } : { display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <UploadFile style={{ width: '10vh', height: '10vh' }} />
                    <MDTypography variant="h4" style={{ textAlign: 'center' }}>
                        Drag {props.isExcel ? 'Excel' : 'CSV'} or click here
                    </MDTypography>
                </div>
                <FormHelperText>{fieldState.error?.message}</FormHelperText>
            </FormControl>
        </div>
    )
}
